{
    "UNjcL": {
        "position": {
            "x": 19,
            "y": 29,
            "z": 1
        },
        "key": "UNjcL",
        "tag": "spawn"
    },
    "D6tiM": {
        "position": {
            "x": 23,
            "y": 29,
            "z": 1
        },
        "key": "D6tiM",
        "tag": "spawn"
    },
    "1o1VC": {
        "position": {
            "x": 29,
            "y": 13,
            "z": 1
        },
        "key": "1o1VC",
        "tag": "spawn"
    },
    "YWIYS": {
        "position": {
            "x": 18,
            "y": 13,
            "z": 1
        },
        "key": "YWIYS",
        "tag": "spawn"
    },
    "_ArrG": {
        "position": {
            "x": 18,
            "y": 14,
            "z": 1
        },
        "key": "_ArrG",
        "tag": "spawn"
    },
    "imcW6": {
        "position": {
            "x": 18,
            "y": 15,
            "z": 1
        },
        "key": "imcW6",
        "tag": "spawn"
    },
    "3T7Cx": {
        "position": {
            "x": 22,
            "y": 14,
            "z": 1
        },
        "key": "3T7Cx",
        "tag": "spawn"
    },
    "EefNP": {
        "position": {
            "x": 22,
            "y": 13,
            "z": 1
        },
        "key": "EefNP",
        "tag": "spawn"
    }
}